import { useUser } from '..';

export function useIsUserAuth(): boolean {
  const { user } = useUser();

  return !!user;
}
